import React from 'react';
import { Button, Card, Modal } from 'react-bootstrap';
import { FaEnvelope, FaExclamationTriangle, FaPhone } from 'react-icons/fa';

const BranchLicenseModal = ({ show, onHide }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="md"
      centered
      className="license-expired-modal"
    >
      <Modal.Header className="border-0 pb-0">
        <div className="w-100 text-center">
          <FaExclamationTriangle className="text-warning" size={50} />
        </div>
      </Modal.Header>
      <Modal.Body className="text-center px-4 pt-0">
        <h4 className="mb-3">Branch License Expired</h4>
        <p className="text-muted mb-4">
          Your branch's license has expired. Please contact to renew the license.
        </p>
        
        <Card className="bg-light border-0 mb-4">
          <Card.Body className="p-3">
            <h6 className="mb-3">Contact Options:</h6>
            <div className="d-flex align-items-center justify-content-center mb-2">
              <FaEnvelope className="text-primary me-2" />
              <span>info@valuecraftminds.com</span>
            </div>
            <div className="d-flex align-items-center justify-content-center">
              <FaPhone className="text-primary me-2" />
              <span>+94 76 020 06320</span>
            </div>
          </Card.Body>
        </Card>

        <div className="text-center">
          <Button 
            variant="primary" 
            className="px-4 mb-2"
            onClick={onHide}
          >
            Okay, I Understand
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default BranchLicenseModal;